import React from 'react';
import { AlertCircle } from 'lucide-react';
import { useLanguage } from '../../../contexts/LanguageContext';

export const WarningMessage = () => {
  const { translations } = useLanguage();

  return (
    <div className="flex items-start gap-3 bg-yellow-50 text-yellow-700 p-4 rounded-lg">
      <AlertCircle className="shrink-0 mt-0.5" size={20} />
      <div className="text-sm">
        <p className="font-medium">
          {translations?.warningMessage?.title || 'Important Warning'}
        </p>
        <p>
          {translations?.warningMessage?.message ||
            'Make sure the file follows the required template. Download the example template to see the correct format.'}
        </p>
        <ul className="mt-2 list-disc list-inside">
          <li>
            {translations?.warningMessage?.identifierType ||
              'Use identifier_type column to specify "passport" or "email"'}
          </li>
          <li>
            {translations?.warningMessage?.identifier ||
              'Provide either passport number or email in the identifier column'}
          </li>
          <li>
            {translations?.warningMessage?.guideName ||
              'Guide name must match exactly (use copy button above)'}
          </li>
        </ul>
      </div>
    </div>
  );
};